import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const style = {
  boxButtonValue: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  buttonValue: {
    height: 42,
    width: 110.36,
    borderRadius: 24,
    border: '2px solid #5CA7DF',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    marginRight: 6,
    outline: 'none',
    color: '#5CA7DF',
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: 1,
    fontFamily: 'Fira Sans',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#5CA7DF',
      color: '#FFFFFF',
    }
  },
};

const ButtonDevice = ({ classes, onChangeDevice, onChangeModal }) => {
  function setValue(event) {
    const value = Number(event.target.value);
    onChangeDevice(value);
    onChangeModal(false);
  }

  return (
    <div className={classes.boxButtonValue}>
      <button className={classes.buttonValue} type="button" value={100} onClick={setValue}>
          100
      </button>
      <button className={classes.buttonValue} type="button" value={1000} onClick={setValue}>
          1,000
      </button>
      <button className={classes.buttonValue} type="button" value={10000} onClick={setValue}>
          10,000
      </button>
    </div>
  );
};

ButtonDevice.propTypes = {
  classes: PropTypes.object.isRequired,
  onChangeDevice: PropTypes.func.isRequired,
  onChangeModal: PropTypes.func.isRequired,
};

export default injectSheet(style)(ButtonDevice);
